const frequencyOptions = [
  { value: true, label: 'Often' },
  { value: false, label: 'Rarely' },
]

export const questions = [
  {
    name: 'usedProgressiveLenses',
    text: 'Has your client worn progressive lenses before?',
  },
  {
    name: 'further',
    text: 'Further',
    options: frequencyOptions,
  },
  {
    name: 'intermediate',
    text: 'Intermediate',
    options: frequencyOptions,
  },
  {
    name: 'closer',
    text: 'Closer',
    options: frequencyOptions,
  },
]

const Short = [
  [1, 1, 0, 1], // YYNY
  [1, 1, 0, 0], // YYNN
  [1, 0, 0, 1], // YNNY
  [1, 0, 0, 0], // YNNN
]

const defaultResult = 'Soft'

export default {
  questions,
  evaluationMap: { Short },
  defaultResult,
  title: 'Select frequency of use of vision areas',
}
